import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { BaseDialogOptions } from '../dialogoptions';

import { ReportInfo } from 'services/reports/reports.service';

@Component({
    selector: 'dialog-reportoptions-component',
    styleUrls: ['reportoptions.dialogcomponent.scss'],
    templateUrl: 'reportoptions.dialogcomponent.html',
})
export class ReportOptionsDialogComponent implements OnInit {
    title: string;
    message: string;
    oktext: string;
    canceltext: string;
    showIcon: boolean;

    AllSchoolYears: string[];
    OptionsForm: FormGroup;
    ReportInfo: ReportInfo;
    SchoolYear: string;

    constructor(
        private dialogRef: MatDialogRef<ReportOptionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: BaseReportOptionsDialogOptions,
        private fb: FormBuilder
    ) {
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';

        this.AllSchoolYears = data.AllSchoolYears || [];
        this.ReportInfo = data.ReportInfo;

        const syear = this.AllSchoolYears && !!this.AllSchoolYears.length ? this.AllSchoolYears[0] : null;

        this.OptionsForm = this.fb.group({
            ReportYear: [syear, Validators.required],
        });
    }

    ngOnInit() {}

    CancelHandler() {
        this.dialogRef.close(null);
    }

    OKHandler() {
        const form = this.OptionsForm.value;

        this.dialogRef.close(<BaseReportOptionsResult>{
            ReportInfo: this.ReportInfo,
            ReportSchool: form.ReportSchool,
            ReportYear: form.ReportYear,
            ReportJudgingPhase: form.ReportJudgingPhase,
        });
    }
}

export class BaseReportOptionsDialogOptions extends BaseDialogOptions {
    AllSchoolYears?: string[];
    ReportInfo?: ReportInfo;
}

export class BaseReportOptionsResult {
    ReportInfo: ReportInfo;
    ReportYear: string;
}
